<template>
<loader v-bind="{ loading }">
    <columns>
      <column>
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <action-button @click="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </action-button>
            </div>
          </template>
        </text-input>
      </column>
      <column class="is-narrow is-flex align-end">
        <router-link 
          class="button is-small is-rounded"
          :to="{
            name: 'new-vulnerability'
          }">
          <icon icon="plus"/>
          <span>Cwe</span>
        </router-link>
      </column>
    </columns>

    <div>
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Number</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cwe in cwes.data" :key="cwe.id">
              <td>
                <router-link
                  :to="{
                    name: 'edit-cwe',
                    params: {
                      cwe: cwe.id
                    }
                  }">CWE-{{ cwe.number }}</router-link>
                <p class="has-text-grey">
                  {{ cwe.description }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <pager 
          class="mb-1"
          :pageable="cwes" 
          @nav="goToPage"
          jump-controls
          context="Cwe"/>
      </div>
    </div>
</loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Cwes',

  data: () => ({
    cwes: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadCwes()
  },

  methods: {
    loadCwes() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.cwes = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'cwes',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'cwes',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  watch: {
    '$route': 'loadCwes'
  }

}
</script>
